import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppUrlService {

    private urls : any = {
        partnerLogo :'paynow/logo',
        login : 'paynow/auth/',
        paymentMethods: 'paynow/paymentMethods',
        makePayment: 'paynow/payment',
        orderReceipt: 'order/receipt/',
        refreshToken: 'paynow/auth/refreshToken/',
        appleValidation: 'payment/appleValidation'
      }

      getURL(urlString : string) : string{
        return environment.pays_service + this.urls[urlString];
      }
}
